<!-- 
	CustomerServiceBanner
	props: N/A
  	role: Public
	Called across the application to display customer service information to users
-->

<template>
  <div
    class="customer-service-banner bg-white py-12 px-6 text-black"
  >
    <div class="text-2xl font-bold mb-4">
      If you have any further questions or concerns, please contact customer
      service at<br>
      <a
        href="tel:+18445946946"
        class="winwin-aqua"
      >1 (866) 594 - 6946</a>
    </div>
    <div>
      Customer Service Representatives are Available Weekdays from 8am to 5pm
    </div>
  </div>
</template>
<script>
	export default {
		name: "CustomerServiceBanner",
	};
</script>
